var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.75C17.25 14.4739 17.0261 14.25 16.75 14.25C16.4739 14.25 16.25 14.4739 16.25 14.75V26.75C16.25 27.0261 16.4739 27.25 16.75 27.25C17.0261 27.25 17.25 27.0261 17.25 26.75V14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.25C14.25 14.6977 13.8023 14.25 13.25 14.25C12.6977 14.25 12.25 14.6977 12.25 15.25V26.25C12.25 26.8023 12.6977 27.25 13.25 27.25C13.8023 27.25 14.25 26.8023 14.25 26.25V15.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.75C20.25 14.4739 20.0261 14.25 19.75 14.25C19.4739 14.25 19.25 14.4739 19.25 14.75V26.75C19.25 27.0261 19.4739 27.25 19.75 27.25C20.0261 27.25 20.25 27.0261 20.25 26.75V14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 15.25C24.25 14.6977 23.8023 14.25 23.25 14.25C22.6977 14.25 22.25 14.6977 22.25 15.25V26.25C22.25 26.8023 22.6977 27.25 23.25 27.25C23.8023 27.25 24.25 26.8023 24.25 26.25V15.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 15.25C28.25 14.6977 27.8023 14.25 27.25 14.25C26.6977 14.25 26.25 14.6977 26.25 15.25V26.25C26.25 26.8023 26.6977 27.25 27.25 27.25C27.8023 27.25 28.25 26.8023 28.25 26.25V15.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.25H7.25C6.69772 10.25 6.25 10.6977 6.25 11.25V16M26.75 10.25H33.25C33.8023 10.25 34.25 10.6977 34.25 11.25V16M34.25 25.5V30.25C34.25 30.8023 33.8023 31.25 33.25 31.25H26.75M13.75 31.25H7.25C6.69771 31.25 6.25 30.8023 6.25 30.25V25.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 24,
    fill: "white",
    transform: "translate(5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerWhite);
export default __webpack_public_path__ + "static/media/scanner-white.d4ba1a3bc27f6d20b6c6f0c02ea79eed.svg";
export { ForwardRef as ReactComponent };